import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '../../../user/permissions';
import { useHistory } from 'react-router-dom';
import { WeezHeader, Dropdown, Status, ButtonDropdown, Button, Icon } from '@weezevent/nacre';
import WidgetList from '../widgetList';

export default function ModulesList({ organizationId }) {
    const { t } = useTranslation();
    const permissions = usePermissions();
    const history = useHistory();

    const dropdown_items = [
        <Dropdown.Item key={0} item={t('ticket.widget.list.addMutliEventWidget')} onClick={() => history.replace(`/ticket/O${organizationId}/widgets/new`)} />,
        <Dropdown.Item key={1} item={t('ticket.widget.list.addFilteredWidget')} onClick={() => history.replace(`/ticket/O${organizationId}/widgets/filtered/new`)} />
    ];

    if (permissions.hasRole('admin')) {
        dropdown_items.push(<Dropdown.Line />);
        dropdown_items.push(
            <Dropdown.Item
                key={2}
                item={
                    <>
                        {t('ticket.widget.list.addNewWidget')}
                        <Status text="Admin" />
                    </>
                }
                onClick={() => history.replace(`/ticket/O${organizationId}/widgets/neo/new`)}
            />
        );
    }

    return (
        <>
            <WeezHeader
                title={t('ticket.widget.list.title')}
                rightComponent={[
                    <ButtonDropdown
                        key="item-1"
                        items={dropdown_items}
                        trigger={<Button primary icon={<Icon name={'plus'} margin={false} />} label={t('ticket.widget.list.dropdownWidget')} />}
                    />
                ]}
            />
            <WidgetList withWidgetEvents organizationId={organizationId} />
        </>
    );
}
